import React from 'react';
import { Grid, Paper, OutlinedInput, InputLabel, Button, Box, FormControlLabel, Checkbox, FormHelperText } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Cancel';
import PageHeader from '../../../components/page-header';
import { usePoliticalPartyCreateEditController } from './context/political-party-create-edit-controller';
import { usePoliticalPartyCreateEditState } from './context/political-party-create-edit-context';

export function PoliticalPartyCreateEditComponent() {
    const { handleOnChange, handleSave, handleCancel, isSaving } = usePoliticalPartyCreateEditController();
    const { partyRequest, showValidationErrors, partyId } = usePoliticalPartyCreateEditState();

    const isEdit = !!partyId;

    return (
        <React.Fragment>
            <Grid item xs={12}>
                <PageHeader
                    title={isEdit ? 'Editar Partido Político' : 'Novo Partido Político'}
                    subtitle="Preencha os dados do partido político"
                    breadcrumbs={[{ label: 'Partidos Políticos', href: '/partidos-politicos' }, { label: isEdit ? 'Editar' : 'Novo' }]}
                />
            </Grid>
            <Grid item xs={12}>
                <Paper sx={{ p: 3 }}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={8}>
                            <InputLabel required>Nome</InputLabel>
                            <OutlinedInput
                                fullWidth
                                name="name"
                                value={partyRequest.name || ''}
                                onChange={handleOnChange}
                                error={showValidationErrors && !partyRequest.name}
                            />
                            {showValidationErrors && !partyRequest.name && <FormHelperText error>Nome é obrigatório</FormHelperText>}
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <InputLabel required>Sigla</InputLabel>
                            <OutlinedInput
                                fullWidth
                                name="abbreviation"
                                value={partyRequest.abbreviation || ''}
                                onChange={handleOnChange}
                                error={showValidationErrors && !partyRequest.abbreviation}
                            />
                            {showValidationErrors && !partyRequest.abbreviation && <FormHelperText error>Sigla é obrigatória</FormHelperText>}
                        </Grid>
                        <Grid item xs={12}>
                            <FormControlLabel
                                control={<Checkbox name="isActive" checked={!!partyRequest.isActive} onChange={handleOnChange} />}
                                label="Ativo"
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Box sx={{ display: 'flex', gap: 1, justifyContent: 'flex-end' }}>
                                <Button variant="outlined" startIcon={<CancelIcon />} onClick={handleCancel}>Cancelar</Button>
                                <LoadingButton variant="contained" startIcon={<SaveIcon />} onClick={handleSave} loading={isSaving} disabled={isSaving}>Salvar</LoadingButton>
                            </Box>
                        </Grid>
                    </Grid>
                </Paper>
            </Grid>
        </React.Fragment>
    );
}
